/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S10_TitleInputs */

const en_fc_tut_s10_title = /** @type {(inputs: Fc_Tut_S10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export your video`)
};

/**
* | output |
* | --- |
* | "Export your video" |
*
* @param {Fc_Tut_S10_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s10_title = /** @type {((inputs?: Fc_Tut_S10_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S10_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s10_title(inputs)
});
export { fc_tut_s10_title as "fc.tut.s10.title" }